import de from '../presentation/common/de.json' with { type: 'json' };
import en from '../presentation/common/en.json' with { type: 'json' };
import { CATEGORY_KEYS, canonicalCategoryKey } from './categoryKeys.js';

export const MILESTONE_LEVELS = [2, 5, 10, 30, 50, 70, 100];

export function milestoneXp(level) { return level === 1 ? 0 : 50 * level * level; }
export function unlockedMilestones(xp) { return MILESTONE_LEVELS.filter(level => Number(xp) >= milestoneXp(level)); }
export function categoryTitle(categoryKey, level, language = 'de') {
  const index = MILESTONE_LEVELS.indexOf(Number(level));
  const titles = (language?.startsWith('de') ? de : en).category_milestones.titles;
  return titles[canonicalCategoryKey(categoryKey)]?.[index] || '';
}
export function parseCategoryTitle(value) {
  const [categoryKey, levelText] = String(value || '').split(':');
  const level = Number(levelText);
  return MILESTONE_LEVELS.includes(level) && CATEGORY_KEYS.includes(categoryKey) ? { categoryKey, level } : null;
}
